import type { PairingCodeSummary } from "@/services/screen-budget/contracts";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface EnrollmentCardProps {
  selectedFamilyId: number | null;
  pairingTtlSeconds: string;
  onPairingTtlSecondsChange: (value: string) => void;
  latestPairingCode: PairingCodeSummary | null;
  onCreatePairingCode: () => Promise<void>;
  isCreatingPairingCode: boolean;
}

export function EnrollmentCard({
  selectedFamilyId,
  pairingTtlSeconds,
  onPairingTtlSecondsChange,
  latestPairingCode,
  onCreatePairingCode,
  isCreatingPairingCode,
}: EnrollmentCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Device Enrollment</CardTitle>
        <CardDescription>Generate a one-time pairing code for the selected family.</CardDescription>
      </CardHeader>
      <CardContent className="grid gap-3 md:grid-cols-[220px_auto]">
        <div className="grid gap-2">
          <Label htmlFor="screen-budget-admin-ttl">TTL seconds</Label>
          <Input
            id="screen-budget-admin-ttl"
            value={pairingTtlSeconds}
            onChange={event => onPairingTtlSecondsChange(event.currentTarget.value)}
            inputMode="numeric"
          />
        </div>
        <div className="flex flex-wrap items-end gap-3">
          <Button
            type="button"
            disabled={selectedFamilyId === null || isCreatingPairingCode}
            onClick={() => void onCreatePairingCode()}
          >
            {isCreatingPairingCode ? "Generating..." : "Generate pairing code"}
          </Button>
          {latestPairingCode ? (
            <p className="text-sm text-muted-foreground">
              <span className="font-mono text-foreground">{latestPairingCode.code}</span> expires{" "}
              {new Date(latestPairingCode.expiresAt).toLocaleString()}
            </p>
          ) : null}
        </div>
      </CardContent>
    </Card>
  );
}
